import React from "react";
import {
  FormControl,
  Select,
  MenuItem,
  OutlinedInput,
  InputAdornment,
  Tooltip,
  IconButton,
} from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import CancelIcon from "@mui/icons-material/Cancel";

const VideoFilter = ({
  problems,
  keysWithOperators,
  setKeysWithOperators,
  setCurrentPage,
}) => {
  const hasVideosFilter = keysWithOperators.find(
    (filter) => filter.key === "problemVideos"
  );
  const selectedValue = hasVideosFilter
    ? hasVideosFilter.searchTerm === "true"
      ? "With Video"
      : "Without Video"
    : "";

  const handleChange = (event) => {
    const value = event.target.value;
    setCurrentPage(1);

    if (value === "") {
      // Remove hasVideos filter
      setKeysWithOperators((prev) =>
        prev.filter((filter) => filter.key !== "problemVideos")
      );
    } else {
      // Add or update hasVideos filter
      const newFilter = {
        key: "problemVideos",
        operator: "specified",
        searchTerm: value === "With Video" ? "true" : "false",
      };
      setKeysWithOperators((prev) => {
        const otherFilters = prev.filter(
          (filter) => filter.key !== "problemVideos"
        );
        return [...otherFilters, newFilter];
      });
    }
  };

  const handleClearFilter = () => {
    setCurrentPage(1);
    setKeysWithOperators((prev) =>
      prev.filter((filter) => filter.key !== "problemVideos")
    );
  };

  const tooltipTitle =
    selectedValue === "With Video"
      ? "Showing problems with video explanations"
      : selectedValue === "Without Video"
      ? "Showing problems without video explanations"
      : "Filter problems by video explanation availability";

  return (
    <Tooltip title={tooltipTitle} placement="top" arrow>
      <FormControl
        sx={{
          m: 0.5,
          "& .MuiOutlinedInput-root": { borderRadius: "16px" },
          width: 120,
        }}
        size="small"
      >
        <Select
          value={selectedValue}
          onChange={handleChange}
          displayEmpty
          renderValue={(selected) => (selected ? selected : <span>Video</span>)}
          MenuProps={{ PaperProps: { style: { maxHeight: 300 } } }}
          {...(selectedValue && {
            sx: {
              "& .MuiSelect-icon": { right: 0 },
              "& .MuiSelect-select": {
                paddingRight: "0px !important",
              },
            },
          })}
          input={
            <OutlinedInput
              startAdornment={
                <InputAdornment position="start">
                  <PlayArrowIcon sx={{ fontSize: "medium" }} />
                </InputAdornment>
              }
              endAdornment={
                selectedValue && (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="Clear video filter"
                      onClick={handleClearFilter}
                      size="small"
                      color="error"
                    >
                      <CancelIcon sx={{ fontSize: "medium" }} />
                    </IconButton>
                  </InputAdornment>
                )
              }
            />
          }
        >
          <MenuItem value="With Video">With Video</MenuItem>
          <MenuItem value="Without Video">Without Video</MenuItem>
        </Select>
      </FormControl>
    </Tooltip>
  );
};

export default VideoFilter;
